import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MenuModel } from '@bo-client/core/navigation/menu.model';
import { NavigationService } from '@bo-client/core/navigation/navigation.service';
import { CURRENT_TENANT } from '@shared/variables';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantDto, Theme } from '@bo-client/shared/models/tenantDto';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { AuthenticationService } from '@bo-client/core';

@Component({
  selector: 'app-view-menu',
  templateUrl: './view-menu.component.html',
  styleUrls: ['./view-menu.component.scss']
})
export class ViewMenuComponent implements OnInit {
  @Input() menu: MenuModel[];
  @Input() menuIsExpanded: boolean;
  @Input() tooltipPlacement: string;
  @Input() disableTooltips: boolean;
  @Output() clickedItem = new EventEmitter();

  theme: Theme = new Theme();

  constructor(
    private navigationService: NavigationService,
    private dataShareService: DataShareService,
    private authenticationService: AuthenticationService
  ) {
    dataShareService.theme$.subscribe((x) => {
      if (x) this.theme = x;
    });
  }

  ngOnInit(): void {
    this.authenticationService.isLoggedIn$.subscribe((isLoggedIn) => {
      this.menu = this.navigationService.generateMenu(this.menu);
    });
  }

  clickOnItem(valueAction: string) {
    this.clickedItem.emit(valueAction);
  }

  waitingForLogin() {}
}
